import { render, staticRenderFns } from "./CotacaoConjuntaMinhaRespostaDadosBasicos.vue?vue&type=template&id=4648d32c&"
import script from "./CotacaoConjuntaMinhaRespostaDadosBasicos.vue?vue&type=script&lang=js&"
export * from "./CotacaoConjuntaMinhaRespostaDadosBasicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
